import { createContext } from "react";

import { type ThirdPartyInfo } from "helpers/AppProvider.types";

/**
 * Context containing third party configuration values, like **public** API keys
 * and third party base URLs
 */
export const ThirdPartyInfoContext = createContext<ThirdPartyInfo | undefined>(undefined);
